import { isRedirectedFromMollie } from 'relapp-helpers';

export default {
    computed: {
        /**
         * Check if we are redirected from mollie after the payment is failed.
         *
         * @return {boolean}
         */
        isRedirectedFromMollie() {
            return isRedirectedFromMollie(mollieConfig.redirectQueryParam);
        },
        /**
         * Get the current url.
         *
         * @return {string}
         */
        currentUrl() {
            return [window.location.protocol, '//', window.location.host, window.location.pathname].join('');
        },
        /**
         * Get the confirmation url.
         *
         * @return {string}
         */
        confirmationUrl() {
            const confirmationRoute = this.$router.resolve({ name: 'orderFullConfirmation' });

            return [window.location.protocol, '//', window.location.host, confirmationRoute.href].join('');
        }
    }
};
